
export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/00d6ba5a9a795909e71b3f82ee53302a.png')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 text-center text-white">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 leading-tight" style={{ fontFamily: '"Pacifico", serif' }}>
          伝説の
          <br className="sm:hidden" />
          ヘッドスパ
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl mb-6 sm:mb-8 font-light px-2">
          45年の経験が生み出す、特別なケア体験
        </p>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4">
          長年の研究と実績に基づく独自のメソッドで、多くの方に喜びの声をいただいております。
          専門家による丁寧なカウンセリングと、一人ひとりに合わせたケアをご提供します。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-amber-600 hover:bg-amber-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            ご相談・お問い合わせ
          </button>
          <button 
            onClick={() => window.REACT_APP_NAVIGATE('/salons')}
            className="border-2 border-white hover:bg-white hover:text-gray-900 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            サロン紹介
          </button>
        </div>
      </div>
    </section>
  );
}
